<template>
  <div :class="overlayClasses">
    <!-- placement -->
    <div
      v-if="params.data.placements.length"
      class="placements"
    >
      <div
        class="placements-list"
        :style="placementsStyles.default"
      >
        <div
          v-for="(place, index) in params.data.placements"
          :key="index"
          class="placements-list__item"
          :class="{'is-zero': place == 0}"
          :style="place == 1 ? placementsStyles.first : placementsStyles.other"
        >
          {{ place || 'X' }}
        </div>
      </div>
    </div>

    <!-- stats -->
    <div class="round-wrapper">
      <div
        class="round-text"
        :style="statsStyles"
      >
      {{ roundCountText }}
      </div>
    </div>

    <!-- username -->
    <div class="username-wrapper">
      <div
        class="username"
        :style="userStyles"
      >
        {{ params.data.user.name }}
      </div>
    </div>

    <!-- main -->
    <div
      v-if="params"
      :class="['wz-overlay', {'has-avatar': params.data.user.avatar}]"
      :style="overlayStyles.default"
    >
      <div
        v-if="params.data.user.avatar"
        class="overlay-avatar"
      >
        <img
          :style="{borderRadius: `calc(${params.styles.overlay.borderRadius}px/2)`}"
          :src="params.data.user.avatar"
          alt=""
        >
      </div>
      <div
        v-for="(item, index) in firstData"
        :key="index"
        class="wz-overlay-section"
      >
        <div
          class="wz-overlay-section__value"
          :style="overlayStyles.text"
        >
          {{ item.value }}
        </div>
        <div
          class="wz-overlay-section__label"
          :style="overlayStyles.label"
        >
          {{ item.label }}
        </div>
      </div>
      <div
        class="frame"
        :style="sliderStyles.default"
      >
        <div
          class="frame-slide"
        >
          <!-- main frame slider -->
          <div
            class="slide slide-1"
            :style="sliderStyles.text"
          >
            <div class="logo-text">
              ZEYPLAY.COM
            </div>
          </div>

          <!--  -->
          <div
            v-for="item in params.data.rounds"
            :key="item.round"
            :class="['slide', `slide-${item.round + 1}`]"
            :style="sliderStyles.text"
          >
            <div class="slide-data">
              <div
                class="slide-data__item"
                :class="{'is-zero': item.kills == 0}"
              >
                {{item.kills || 'X'}}
                <span>kills</span>
              </div>
              <div
                class="slide-data__item"
                :class="{'is-zero': item.place == 0}"
              >
                {{item.place || 'X'}}
                <span>place</span>
              </div>
             <div
                class="slide-data__item"
                :class="{'is-zero': item.pts == 0}"
              >
                {{item.pts || 'X'}}
                <span>pts</span>
              </div>
            </div>
            <div class="slide-round">
              round {{item.round}}
            </div>
          </div>

          <!-- finish event slide -->
          <div
            v-if="params.data.event_finished"
            class="slide slide-finish"
            :style="sliderStyles.text"
          >
            <div class="finish-text">
             TOURNAMENT<br>IS FINISHED
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const animationSettings = {
  opacityIn: [0, 1],
  scaleIn: [0.2, 1],
  scaleOut: 3,
  durationIn: 800,
  durationOut: 600,
  delay: 5000,
};

export default {
  name: 'ZPOverlay',

  props: {
    params: {
      type: Object,
      default: null,
    },
    updateData: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      timer: null,
      initInterval: null,
      timerData: {
        seconds: 0,
        minutes: 0,
        hour: 0,
      },
    };
  },

  computed: {

    roundCountText() {
      return this.params.data.bestof === this.params.data.rounds_count
        ? `${this.params.data.rounds_count} games`
        : `${this.params.data.bestof} best of ${this.params.data.rounds_count}`;
    },

    overlayStyles() {
      return {
        default: {
          backgroundColor: this.params.styles.overlay.backgroundColor,
          borderColor: this.params.styles.overlay.borderColor,
          borderRadius: `${this.params.styles.overlay.borderRadius}px`,
          borderWidth: `${this.params.styles.overlay.borderWidth}px`,
        },
        text: {
          color: this.params.styles.overlay.textColor,
        },
        label: {
          color: this.params.styles.overlay.labelColor,
        },
      };
    },

    sliderStyles() {
      return {
        text: {
          color: this.params.styles.slider.textColor,
        },
        label: {
          color: this.params.styles.slider.labelColor,
        },
        default: {
          backgroundColor: this.params.styles.slider.backgroundColor,
        },
      };
    },

    userStyles() {
      return {
        color: this.params.styles.user.color,
        backgroundColor: this.params.styles.user.backgroundColor,
        borderRadius: `${this.params.styles.user.borderRadius}px`,
      };
    },

    statsStyles() {
      return {
        color: this.params.styles.stats.color,
        backgroundColor: this.params.styles.stats.backgroundColor,
        borderRadius: `${this.params.styles.user.borderRadius}px`,
      };
    },

    placementsStyles() {
      return {
        default: {
          backgroundColor: this.params.styles.placements.backgroundColor,
          borderTopLeftRadius: `${this.params.styles.placements.borderRadius}px`,
          borderTopRightRadius: `${this.params.styles.placements.borderRadius}px`,
        },
        first: {
          backgroundColor: this.params.styles.placements.firstColor,
          borderRadius: `${this.params.styles.placements.borderRadius}px`,
        },
        other: {
          backgroundColor: this.params.styles.placements.otherColor,
          borderRadius: `${this.params.styles.placements.borderRadius}px`,
        },
      };
    },

    overlayClasses() {
      return [
        'wz-overlay-wrapper',
      ];
    },

    /**
     * @description данные для первого слайда (который статичен)
     */
    firstData() {
      return [
        {
          label: this.params.options.session.visible ? 'session kd' : 'position',
          value: this.params.data?.position,
        },
        {
          label: this.params.options.session.visible ? 'session wins' : 'total kills',
          value: this.params.data?.total_kills,
        },
        {
          label: this.params.options.session.visible ? 'session kpg' : 'total pts',
          value: this.params.data?.total_pts,
        },
      ];
    },
  },

  beforeDestroy() {
    clearInterval(this.initInterval);
  },

  mounted() {
    this.createAnimation();
  },

  methods: {

    async reload() {
      await this.updateData();
      this.createAnimation();
    },

    /**
     * @description метод добавления кадра анимации
     */
    addFrame(animation, i = 0) {
      if (i < this.params.data.rounds.length) {
        const target = `.frame .slide-${this.params.data.rounds[i].round + 1}`;
        this.addFrame(
          animation.add({
            targets: target,
            opacity: animationSettings.opacityIn,
            scale: animationSettings.scaleIn,
            duration: animationSettings.durationIn,
          }).add({
            targets: target,
            opacity: 0,
            scale: animationSettings.scaleOut,
            duration: animationSettings.durationOut,
            easing: 'easeInExpo',
            delay: animationSettings.delay,
          }),
          i + 1,
        );
      }
    },

    /**
     * @description создание анимации стайдов
     */
    createAnimation() {
      const animation = this.$anime.timeline({
        loop: this.params.stop,
        loopComplete: () => {
          if (!this.params.data.event_finished || !this.params.stop) {
            this.reload();
          }
        },
      });
      // add start frame
      animation.add({
        targets: '.frame',
        keyframes: [
          { translateX: -290, duration: 500 },
        ],
        easing: 'easeOutElastic(1, .8)',
        delay: 3000,
      }).add({
        targets: '.frame .slide-1',
        opacity: animationSettings.opacityIn,
        scale: animationSettings.scaleIn,
        duration: animationSettings.durationIn,
      }).add({
        targets: '.frame .slide-1',
        opacity: 0,
        scale: animationSettings.scaleOut,
        duration: animationSettings.durationOut,
        easing: 'easeInExpo',
        delay: animationSettings.delay,
      });

      // add collection frames
      this.addFrame(animation);

      // add finish slide
      if (this.params.data.event_finished) {
        animation.add({
          targets: '.frame .slide-finish',
          opacity: animationSettings.opacityIn,
          scale: animationSettings.scaleIn,
          duration: animationSettings.durationIn,
        }).add({
          targets: '.frame .slide-finish',
          opacity: 0,
          scale: animationSettings.scaleOut,
          duration: animationSettings.durationOut,
          easing: 'easeInExpo',
          delay: animationSettings.delay,
        });
      }

      // add end frame
      animation.add({
        targets: '.frame',
        keyframes: [
          { translateX: 300, duration: 500 },
        ],
        easing: 'linear',
      });

      animation.finished.then(this.test);
    },

    /**
     * @description формирование строки "last n games"
     */
    getLastGamesString(text, count) {
      return text.replace(/n/, count);
    },

    test() {
      console.log('complete');
    },
  },
};
</script>

<style lang="scss">

.wz-overlay-wrapper {
  position: relative;
  display: inline-flex;
  margin-top: 30px;
  padding-top: 0 !important;

  .is-zero {
    color: #fcc207 !important;
  }

  .round-wrapper {
    position: absolute;
    left: 0;
    right: 15px;
    bottom: -10px;
    display: flex;
    justify-content: flex-end;

    .round-text {
      border-radius: 10px;
      background: #000;
      padding: 5px 15px;
      z-index: 4;
      font-size: 11px;
      text-transform: uppercase;
    }
  }

  .placements {
    position: absolute;
    top: -28px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;

    &-list {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      grid-gap: 3px;
      background: blue;
      padding: 3px;

      border-top-right-radius: 5px;
      border-top-left-radius: 5px;

      &__item {
        width: 22px;
        height: 22px;
        background: #000;
        color: #fff;
        font-size: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px;
        border-radius: 3px;
      }
    }
  }

  .username-wrapper {
    position: absolute;
    bottom: -10px;
    left: 15px;
    right: 0;
    display: flex;
    justify-content: flex-start;

    .username {
      border-radius: 10px;
      background: #000;
      padding: 5px 15px;
      z-index: 4;
      font-size: 11px;
      text-transform: uppercase;
      max-width: 160px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.wz-overlay {
  box-sizing: border-box;
  min-width: 350px;
  width: 350px;
  height: 84px;
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  padding: 0 10px;
  background: #1d1d1d;
  border: 0px #fff solid;
  overflow: hidden;

  &.has-avatar {
    min-width: 420px;
    width: 420px;
    grid-template-columns: 70px repeat(3, 1fr);

    .frame {
      width: 60%;
    }
  }

  .overlay-avatar {
    width: 60px;
    height: 60px;
    line-height: 0;

    > img {
      width: 60px;
      height: 60px;
      line-height: 0;
    }
  }

  &-section {
    font-weight: 600;
    font-size: 28px;
    line-height: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__label {
      text-transform: uppercase;
      margin-top: 5px;
      font-size: 12px;
    }
  }

  .frame {
    position: absolute;
    height: 100%;
    top: 0;
    right: -330px;
    width: 72%;

    &:before {
      position: absolute;
      content: "";
      width: 71.1%;
      height: 100%;
      transform-origin: 0 100%;
      transform: skew(-15deg);
      background: inherit;
      z-index: -1;
      left: -26px;
    }

    .frame-slide {
      position: absolute;
      top: 0;
      bottom: 0;
      left: -10px;
      right: 35px;
      height: 100%;
      display: flex;
      align-items: center;
      text-transform: uppercase;
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;

      .slide {
        position: absolute;
        left: 20px;
        top: 0;
        right: 20px;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 22px;
        font-weight: 600;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .logo-text {
        font-size: 24px;
        color: rgb(255, 118, 41);
      }

      .slide-data {
        display: grid;
        grid-template-columns: repeat(3, 1fr);

        &__item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0 12px;
          line-height: 1;
          font-size: 22px;

          span {
            margin-top: 3px;
            font-size: 12px;
            font-weight: 500;
            color: #fff !important;
          }
        }
      }

      .slide-round {
        margin-top: 3px;
        font-size: 10px;
        font-weight: 500;
        color: rgb(255, 118, 41);
      }

      .slide-value {
        margin-right: 5px;
        margin-left: 5px;
      }

       .main-text {
        font-size: 18px;
        display: flex;
        align-items: center;

        span {
          font-size: 18px;
          margin-right: 5px;
        }
      }

      .bottom-text {
        font-size: 12px;
        opacity: 0.8;
        margin-top: 5px;
      }
    }
  }

  .finish-text {
    font-size: 16px;
    text-align: center;
  }
}
</style>
